module.exports = __webpack_public_path__ + "img/JM.9f6f8dd1.svg";